import OSS from "ali-oss";
import { Message } from 'element-ui'
import { BasicsClass } from "@/common/BasicsClass";
import { Util } from "@/common/util";

type videoParams = any

const stsConfigInfo: any = {}

const stsTokenGapTs = 3 * 60 * 1000 // 单位毫秒

export class CommonApi extends BasicsClass {
    // 公共、辅助api接口

    // 图片上传-oss上传凭证
    public getOssConfig(
        params: any,
        successCb: Function,
        failCb: Function,
        showLoading: boolean = false
    ) {

        // autoRefreshNoCacheOss true 时 不使用 stsConfig 缓存 直接重新获取
        if (!params.autoRefreshNoCacheOss) {
            const isEmptyConf: boolean = !(stsConfigInfo && stsConfigInfo.expiration)

            if (!isEmptyConf) {
                const {expiration} = stsConfigInfo || {}

                console.log(stsConfigInfo, 'stsConfigInfo')

                const expireTs = new Date(expiration).valueOf()
                const nowTs = new Date().valueOf()


                const isExpireConfig: boolean = expireTs < nowTs + stsTokenGapTs

                if (!isExpireConfig) {
                    successCb({
                        data: {
                            ...(stsConfigInfo || {})
                        }
                    })
                    return Promise.resolve({
                        data: {
                            ...(stsConfigInfo || {})
                        }
                    })
                }
            }
        }

        return new Promise((resolve, reject) => {
            this.BasicPost(
                "/admin/oss/sts",
                {
                    ...params,
                },
                false,
                false,
                false,
                (res: any) => {
                    const {
                        data: ossConfig
                    } = res || {}

                    Object.assign(stsConfigInfo, {
                        ...(ossConfig || {})
                    })

                    resolve(res)

                    successCb(res)
                },
                (err: any) => {
                    reject(err)

                    failCb(err)
                },
                showLoading
            );
        })
    }

    //获取oss参数 上传文件
    public getOss(
        file: any,
        successCb: Function,
        failCb: Function,
        extraParams: videoParams = {}
    ) {


        this.getOssConfig(
            {},
            (res: any) => {
                const { data: ossConfig } = res || {};

                const {
                    regionId,
                    accessKeyId,
                    accessKeySecret,
                    securityToken,
                    bucket,
                    uploadDir,
                    uploadCallbackUrl,
                } = ossConfig || {};

                const client = new OSS({
                    region: regionId,
                    secure: true, //*这句话很重要！！！！！！！！！
                    accessKeyId,
                    accessKeySecret,
                    stsToken: securityToken,
                    bucket,
                    refreshSTSToken: async () => {
                        // 向您搭建的STS服务获取临时访问凭证。
                        const {
                            res
                        }: any = await this.getOssConfig({ autoRefreshNoCacheOss: true }, () => {}, ()=> {})

                        stsConfigInfo.expiration = res.data.expiration
                        return {
                            accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId或临时秘钥
                            accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret或临时秘钥
                            stsToken: res.data.securityToken, //  从STS服务获取的安全令牌（SecurityToken）。
                        }
                    },
                    // 刷新临时访问凭证的时间间隔，单位为毫秒。  该间隔 比 getOssConfig 间隔更短，保证 外部 this.getOssConfig 一直缓存
                    refreshSTSTokenInterval: 60 * 60 * 1000 - stsTokenGapTs * 1.5
                });

                const {
                    // type: fileType,
                    name: fileName,
                } = file;

                const fileExtension = fileName.substring(fileName.lastIndexOf("."));

                const objectKey = uploadDir + "/" + Util.uuid() + fileExtension;

                const options = {
                    callback: {
                        // 设置回调请求的服务器地址，例如http://oss-demo.aliyuncs.com:23450。
                        url: uploadCallbackUrl,
                        //（可选）设置回调请求消息头中Host的值，即您的服务器配置Host的值。
                        //host: 'yourCallbackHost',
                        // 设置发起回调时请求body的值。
                        body:
                            "bucket=${bucket}&file=${object}&size=${size}&height=${imageInfo.height}&width=${imageInfo.width}&etag=${etag}" +
                            "&upload_type=" +
                            "image",
                        // 设置发起回调请求的Content-Type。
                        contentType: "application/x-www-form-urlencoded",
                    },
                };
                client.put(objectKey, file, options).then(
                    (result) => {

                        successCb(result);
                    },
                    (err: any) => {
                        console.log('err',err)
                        failCb(err);
                    }
                );
            },
            (err: any) => {
                failCb(err);
            }
        );
    }


}
